<div class="container">
  <div class="row flex-center min-vh-100 py-5">
    <div class="col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3">
      <h1 class="text-center mb-4">Мне как обычно</h1>
      <div class="text-center">
        <h3 class="text-1000">Вход</h3>
      </div>
      <div class="mb-3 text-start">
        <label class="form-label">Логин</label>
        <div class="form-icon-container">
          <input type="text" name="userName" [(ngModel)]="userName" (keydown.enter)="login()" class="form-control form-icon-input">
          <i class="fa-solid fa-user text-900 fs--1 form-icon"></i>
        </div>
      </div>

      <div class="mb-3 text-start">
        <label class="form-label">Пароль</label>
        <div class="form-icon-container">
          <input type="password" name="password" [(ngModel)]="password" (keydown.enter)="login()" class="form-control form-icon-input">
          <i class="fa-solid fa-key text-900 fs--1 form-icon"></i>
        </div>
      </div>

      <button type="submit" class="btn btn-primary w-100 mb-3" (click)="login()">Вход</button>

      @if (errorMessage) {
        <div class="alert alert-danger mb-3">
          {{ errorMessage }}
        </div>
      }
    </div>
  </div>
</div>